import request from "@utils/request";
import { ParamsProps, ReturnType } from "./types";

const create = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: `addons`,
      method: "post",
      authorization: true,
      data: args?.data,
      config: {
        successMsg: "Addon Created Successfully",
        showErr: true,
        store: {
          key: args?.state,
          action: "set",
        },
      },
    };
    const response = await request(config);
    return response;
  } catch (err: any) {
    throw new Error(err);
  }
};
const update = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: `addons/${args?.id}`,
      method: "patch",
      authorization: true,
      data: args?.data,
      config: {
        showErr: true,
        store: {
          key: args?.state,
          action: "update",
        },
      },
    };
    const response = await request(config);
    return response;
  } catch (err: any) {
    throw new Error(err);
  }
};
const updateStatus = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: `addons/status/${args?.id}`,
      method: "patch",
      authorization: true,
      data: args?.data,
      config: {
        showErr: true,
        store: {
          key: args?.state,
          action: "update",
        },
      },
    };
    const response = await request(config);
    return response;
  } catch (err: any) {
    throw new Error(err);
  }
};
const removeLensColor = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: `addons/lens-type/${args?.id}`,
      method: "delete",
      authorization: true,
      data: args?.data,
      config: {
        successMsg: "Deleted Successfully",
        showErr: true,
        store: {
          key: args?.state,
          action: "remove",
        },
      },
    };
    const response = await request(config);
    return response;
  } catch (err: any) {
    throw new Error(err);
  }
};

const find = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: "addons",
      method: "get",
      authorization: true,
      params: args?.params,
      config: {
        showErr: true,
      },
    };
    if (args.state) {
      config.config.store = {
        key: args?.state,
        action: "set",
      };
    }
    const response = await request(config);
    return response;
  } catch (err: any) {
    throw new Error(err);
  }
};
export default { find, create, update, removeLensColor, updateStatus };
